import { render, staticRenderFns } from "./Reportofincident.vue?vue&type=template&id=0e04f02c"
import script from "./Reportofincident.vue?vue&type=script&lang=js"
export * from "./Reportofincident.vue?vue&type=script&lang=js"
import style0 from "./Reportofincident.vue?vue&type=style&index=0&id=0e04f02c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports